import { render } from "./FormControl.vue?vue&type=template&id=5f8b4f5a"
import script from "./FormControl.vue?vue&type=script&lang=ts"
export * from "./FormControl.vue?vue&type=script&lang=ts"
script.render = render

export default script